import { useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ROUTE_CONSTANTS from '../constants/RouteConstants';
import { SESSION_STATE } from '../constants/AssessmentConstants';
import useMatch from './useMatch';
import { getFeedbackApi } from '../api/test';
import { MULTI_SESSION_STORAGE_KEY } from '../constants/Proctor';
import { EAudioRecordingStatus } from '../components/ProblemTypes/Audio/constants';

const { HELP_ROUTE, REPORT_ROUTE, MULTI_TAB_ROUTE } = ROUTE_CONSTANTS;

/**
 * This hooks can be used for add global custom redirection logic
 * So we don't need to add the redirection logic at all pages in the app.
 * TODO: Add all global level redirection logic here from the pages.
 */
const useCustomRedirect = () => {
  const history = useHistory();
  const isHelpPage = useMatch(HELP_ROUTE);
  const isReportPage = useMatch(REPORT_ROUTE);
  const isMultiTabPage = useMatch(MULTI_TAB_ROUTE);
  const {
    isTestSubmitting,
    isUploadInProgress,
    isAudioUploadInProgress,
  } = useSelector(state => state.test);

  const {
    testSessionState,
    testSlug,
    redirectionUrl,
    testType,
    isReportEnabled,
    isFeedbackEnabled,
  } = useSelector(
    state => ({
      testSessionState: state.test.session_state,
      testSlug: state.test.slug,
      redirectionUrl: state.test.redirection_url,
      testType: state.test.test_type,
      isReportEnabled: state.test.is_report_enabled,
      isFeedbackEnabled: state.test.is_feedback_enabled,
    }),
    shallowEqual
  );

  const isMultiSessionActive = sessionStorage.getItem(
    MULTI_SESSION_STORAGE_KEY
  );

  if (isMultiSessionActive && !isMultiTabPage)
    history.replace('/multi-session');

  const testCompletionRedirection = () => {
    if (redirectionUrl) window.location.replace(redirectionUrl);
    else if (testType === 'LRN' && isReportEnabled) {
      history.replace(`/test-report/${testSlug}`);
    } else {
      history.replace(`/test/${testSlug}/feedback`);
    }
  };

  const getFeedbackStatus = async () => {
    if (!isFeedbackEnabled) {
      testCompletionRedirection();
      return;
    }
    try {
      const resp = await getFeedbackApi(testSlug);
      if (resp.status === 200) {
        testCompletionRedirection();
      }
    } catch {
      history.replace(`/test/${testSlug}/feedback`);
    }
  };

  useEffect(() => {
    const isVideoUploading = Object.values(isUploadInProgress).filter(
      inProgress => inProgress === true
    );
    const isAudioUploading = Object.values(isAudioUploadInProgress).filter(
      inProgress => inProgress === EAudioRecordingStatus.UPLOADING
    );
    if (
      testSessionState === SESSION_STATE.END &&
      !isHelpPage &&
      !isReportPage &&
      !isTestSubmitting &&
      isVideoUploading.length === 0 &&
      isAudioUploading.length === 0
    ) {
      getFeedbackStatus();
    }
  }, [
    isHelpPage,
    testSessionState,
    testSlug,
    isTestSubmitting,
    isUploadInProgress,
    isAudioUploadInProgress,
  ]);
};

export default useCustomRedirect;
